import { useMutation } from "@tanstack/react-query";
import { DateTime } from "luxon";

import type { LogEntry } from "@apis/calorie-grid/models";

import { GRID_COLUMNS } from "../../../bootstrap/grid.ts";
import { logEntryRepository } from "../../../repository/LogEntryRepository.ts";
import { useAuth } from "../../../shared/contexts/auth/useAuth.ts";
import { useConfig } from "../../../shared/contexts/config/useConfig.ts";
import { useLogEntryActions } from "../../../shared/hooks/useLogEntryActions.ts";
import { placementManager } from "../lib/PlacementManager.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function usePlacementQueueActions() {
  const { userId } = useAuth();
  const { gridEpochId, squareKcal } = useConfig();
  const { invalidateLogEntries } = useLogEntryActions();
  const drop = useMutation({
    mutationFn: async ({
      logEntry,
      squaresPerRow,
    }: {
      readonly logEntry: LogEntry;
      readonly squaresPerRow: number;
    }): Promise<void> => {
      const logEntries = await logEntryRepository.getAllByEpoch(
        userId,
        gridEpochId,
      );

      const cells = placementManager.planDrop({
        calories: logEntry.totalCalories,
        // oxlint-disable-next-line no-warning-comments
        // TODO(APT-271): decide whether the column count is fixed or dynamic.
        columns: GRID_COLUMNS,
        logEntries,
        squareKcal,
        squaresPerRow,
        // oxlint-disable-next-line no-warning-comments
        // TODO(APT-245): read "now" from a shared reactive context.
        today: DateTime.now().startOf("day").toJSDate(),
      });

      await logEntryRepository.update(logEntry, { cells, status: "dropped" });
    },
    onSuccess: invalidateLogEntries,
  });

  return { drop };
}
